// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__QW2wv","checkbox":"Checkbox_checkbox__9Anm8"};